import React, { useEffect } from "react";
import { RoundCard, RunnerUpHeader, TableWork } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useGetEpbGenerationDownloadDeoReportQuery } from "../../../services/reportsServices";
import { useState } from "react";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State name",
  "AC/PC No. and Name",
  "e-PB PIN Transmission Status",
  "Total e-PB generated",
  "Total e-PB downloaded",
  // "Total e-PB booked",
];

const selectConstituencyType = [
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];

const EpbGenerationDownloadDeoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [data, setData] = useState({
    constituencyType: "AC",
  });
  const [tabledata, setTabledata] = useState([]);
  const [skip, setskip] = useState(false);
  // const reportName = "e-Postal Ballot Generation/downloading/booked report"
  // const SheetName = "Generation/downloading/booked Report"
  const reportName = "e-Postal Ballot Generation/downloading Report"
  const SheetName = "Generation/downloading Report"
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col2",
    },
    {
      Header: "e-PB PIN Transmission Status",
      accessor: "col3",
    },
    {
      Header: "Total e-PB generated",
      accessor: "col4",
    },
    {
      Header: "Total e-PB downloaded",
      accessor: "col5",
    },
    // {
    //   Header: "Total e-PB booked",
    //   accessor: "col6",
    // },
  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })

  const { data: GetEpbGenerationDownloadDeoReport } =
    useGetEpbGenerationDownloadDeoReportQuery(data.constituencyType);

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  useEffect(() => {
    var tableData = [];
    if (GetEpbGenerationDownloadDeoReport !== null) {
      GetEpbGenerationDownloadDeoReport?.payload?.map((item) => {
        tableData.push({
          "col1": item.stateName,
          "col2": `${item.acPcNo}-${item.acPcName}`,
          "col3": item.epbGenerationStatus,
          "col4": item.generatedEpbCount,
          "col5": item.downloadedEpbCount,
          // "col6": item.epbBooked,
        });
      });
      setTabledata(tableData);
      setTotalNoOfRecords(GetEpbGenerationDownloadDeoReport?.payload?.length)
      setskip(true);
    }
  }, [GetEpbGenerationDownloadDeoReport]);


  return (
    <LeftMenu>
    <div className="container box shadow ">
      <RunnerUpHeaderNew title={reportName} 
      onPdfClick={() => downloadPdfFile(reportName, tableHeader, tabledata)} 
      onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tabledata)} 
      />
      <div className="row">
        <SelectField
          labelClass=""
          inputClass="col-md-2"
          value={data.constituencyType}
          handleChange={(val) => handleChange("constituencyType", val)}
          options={selectConstituencyType}
        />
      </div>
      <div style={{ marginTop: "-40px" }}>
        <Table
          placeholder="Search"
          globalsearch={true}
          emptyMessage="No Record Found"
          selectall={true}
          columns={columns}
          data={tabledata?.length === 0 ? [] : tabledata}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
    </div>
   </LeftMenu>
  );
};
export default EpbGenerationDownloadDeoReport;
